import { IFileSizeValidator } from '@lialo/core/lib/services/';

export default class FileSizeValidator implements IFileSizeValidator {
  isFileSizeValid(file: any, maxSize: number): boolean {
    return (file as File).size <= maxSize;
  }
}
